import React from "react";
import PageHeader from "../components/PageHeader";
import arrow from "../assets/arrow.svg";
import Help from "../components/Help";
import { helpPagesData } from "../utils/helper";
import EmptyState from "../components/EmptyState";

const NewsLetters = () => {
    const data = [
        { form_name: "Contact Us", Email: "contact@domain.com", Phone: "123-456-7890", Date_Submitted: "2025/03/12 at 7:33 pm", all_responses: "48" },
        { form_name: "News Letter", Email: "newsletter@domain.com", Phone: "098-765-4321", Date_Submitted: "2025/03/12 at 7:33 pm", all_responses: "48" },
    ];
    return (
        <>
            <PageHeader pageTitle="Contact Forms">
         
                    <Help
                        title={helpPagesData.pages.title}
                        message={helpPagesData.pages.message}
                        items={helpPagesData.pages.items}
                    />
                    <button className="btn-black">Export CSV</button>
           
            </PageHeader>
            <div className="page-container">
                {/* <div className="theme-card p-4">
                    <div className="card-title pb-3">All Forms</div>
                    <div className="table-responsive">
                        <table className="pages-table">
                            <thead>
                                <tr>
                                    <th>Form Name</th>
                                    <th>All Responses</th>
                                    <th style={{ textAlign: 'center' }}>Responses</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((data, i) => (
                                    <tr key={i}>
                                        <td style={{ width: '80%' }}>{data.form_name}</td>
                                        <td>{data.all_responses}</td>
                                        <td style={{ textAlign: 'center' }}>
                                            <button><img src={arrow} alt="" /></button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div> */}
                <EmptyState />
            </div>
        </>
    );
};

export default NewsLetters;